import { render, staticRenderFns } from "./ProjectContentRestaurant.vue?vue&type=template&id=75d41ce2"
import script from "./ProjectContentRestaurant.vue?vue&type=script&lang=ts"
export * from "./ProjectContentRestaurant.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports